import React, { useState, useEffect } from 'react';

const SatDropdown = props => {
  const {
    value,
    initOption = null,
    title = '', // 선택 값 상단 표시 문구
    customStyleClass = '',
    options = [],
    disabled = false,
    readOnly = false,
    onChange,
  } = props;

  const [isShow, setIsShow] = useState(false);
  const [dropdownList, setDropdownList] = useState([]);

  useEffect(() => {
    if (initOption) {
      const { useOption = true, label = '', value = '' } = initOption;
      if (useOption && label !== '') {
        setDropdownList([{ label, value }].concat(options));
      } else {
        setDropdownList(options);
      }
    } else {
      setDropdownList(options);
    }
  }, [options, initOption]);

  const getSelectedItemLabel = () => {
    if (value === '') {
      if (initOption) {
        const { label = '' } = initOption;
        return label;
      } else {
        return '선택';
      }
    } else if (dropdownList.length > 0) {
      const option = dropdownList.find(option => option.value === value);
      return option?.label ?? '';
    }
  };

  return (
    <React.Fragment>
      <div
        className={`sel-group-wrap ${
          customStyleClass ? customStyleClass : 'mgb-16'
        }`}
        onClick={() => setIsShow(!isShow)}
      >
        <div
          className={`sel-group${title ? ' type-label' : ''} ${
            isShow ? 'on' : ''
          }`}
          tabIndex="0"
        >
          {title && <span className="sel-tit">{title}</span>}
          <span className="sel-text">{getSelectedItemLabel()}</span>
        </div>
        <ul className="sel-list">
          {dropdownList.map((option, index) => {
            return (
              <li
                key={index}
                className="sel-option"
                onClick={() => onChange(option)}
              >
                {option.label}
              </li>
            );
          })}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default SatDropdown;
